import React, { useEffect } from "react";
import { app } from "@microsoft/teams-js";

export default function Tab() {
    useEffect(() => {
        app.initialize().then(() => {
            app.notifyAppLoaded();
            app.notifySuccess();
        });
    }, []);

    return (
        <div>
            So richten Sie die ebuero App ein.
        </div>
    );
}
